import { pgiCalcItems } from './pgiCalcItems';
import { pgiAuthors } from './authors';

export class CalcHeaders {
  lp: number;
  id: number;
  dateOfCalc: Date;
  year: number;
  month: number;
  authorId: number;
  isPublished: boolean;
  calculatedBy: number;
  correction: number;
  salesValue: number;
  provisionValue: number;
  pgiCalcItems: pgiCalcItems[];
  pgiAuthors: pgiAuthors;
  authorName: string;
  note2: number;
  accountBalance: number;
  settled: boolean;
  provisionValueOrginal: number;
  accountBalanceOrginal: number;
  flag: boolean;
}
